// This is just an example,
// so you can safely delete all default props below

export default {
    title: 'Customer Service',
    my_account: 'My Account',
    admin: 'Admin',
    sign_in: 'Log In',
    sign_up: 'Signup',
    sign_out: 'Log Out',
    home: 'Home',
    orders: 'Orders',
    contents: 'Contents',
    users: 'Users',
    roles: 'Roles',
    claims: 'Claims',
    unauthorized: 'Unauthorized',
    unauthorized_detail: 'Please contact your administrator.'
}
